import { render, staticRenderFns } from "./SolutionVendor.vue?vue&type=template&id=1956f559&"
import script from "./SolutionVendor.vue?vue&type=script&lang=js&"
export * from "./SolutionVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports